module.exports = __webpack_public_path__ + "static/media/pause.47fbe919.svg";